import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';
import { Box, useTheme } from '@mui/material';

import { PageHeaderInputs } from './types';

const neutralPrimary = '#333333';
export const paragraphSm = {
  fontSize: '14px',
  fontWeight: '300',
  color: neutralPrimary
};

function PageHeader({ title, subtitle, buttons }: PageHeaderInputs) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mb: '18px'
      }}
    >
      <Box sx={{ minWidth: '40%', width: 'auto' }}>
        <Typography type="title-xl" color="neutral-primary">
          {title}
        </Typography>
        {subtitle && (
          <Typography type="paragraph-sm" color="neutral-primary">
            {subtitle}
          </Typography>
        )}
      </Box>
      <Box
        style={{
          display: 'flex',
          marginLeft: 'auto'
        }}
      >
        {buttons &&
          buttons.map((button, i) => {
            return (
              <Box key={i} sx={{ ml: '16px' }}>
                {button}
              </Box>
            );
          })}
      </Box>
    </Box>
  );
}

export default PageHeader;
